export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 500];

/**
 * Page-size choices for tables whose backing endpoint caps the page size at
 * 100. Pass as `TableView`'s `pageSizeOptions` so the size changer never offers
 * a page the request would be rejected for.
 */
export const MAX_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
